// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.51 15.59\" fill=\"#231f20\"> <g id=\"be82dd2d-b42d-4ddf-8e73-29a38f667d53\" data-name=\"Calque 2\"> <g id=\"ff66b7f7-d55b-4102-8107-77a31d9cdaaf\" data-name=\"Calque 1\"> <path id=\"a1f06cb1-e09c-47ff-b872-31c773574aff\" data-name=\"Tracé 1\" d=\"M14.57,13.64H9.69a1.95,1.95,0,0,1-3.9,0H.92A.92.92,0,0,1,.05,13a1,1,0,0,1,.29-1.07A3.94,3.94,0,0,0,1.9,8.77V5.85a5.85,5.85,0,1,1,11.69,0V8.77a3.94,3.94,0,0,0,1.56,3.12A.9.9,0,0,1,15.44,13,.92.92,0,0,1,14.57,13.64Z\" fill-rule=\"evenodd\"/> </g> </g> </svg>";
// Exports
module.exports = code;


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader/dist/cjs.js!./src/assets/icons/icon-notification.svg
// module id = aD+7
// module chunks = 34